export default __webpack_public_path__ + "static/media/Pilgrim's Leather Helm.1a6662b6.jpg";